import {
    OBTENER_SUBGRUPOS,
    AGREGAR_SUBGRUPO,
    ELIMINAR_SUBGRUPO,
    ACTUALIZAR_SUBGRUPO,
    SUBGRUPO_ERROR,
    SUBGRUPO_OK,
    SUBGRUPO_ACTUAL,
    OBTENER_SUBGRUPO,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_SUBGRUPOS:
            return {
                ...state,
                subGrupos: action.payload
            }
        case SUBGRUPO_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case SUBGRUPO_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_SUBGRUPO:
            return {
                ...state,
                subGrupos: [...state.subGrupos, action.payload],
                nuevoSubgrupo:[action.payload], 
                formulario: false,
                errorformulario: false
            }
        case SUBGRUPO_ACTUAL:
            return {
                ...state,
                subGrupo: state.subGrupos.find(subg => subg._id === action.payload)
            }
        case ELIMINAR_SUBGRUPO:
            return {
                ...state,
                subGrupos: state.subGrupos.filter(subg => subg._id !== action.payload),
                subGrupo: null
            }
        case ACTUALIZAR_SUBGRUPO:
            return {
                ...state,
                subGrupos: state.subGrupos.map(subg => subg._id === action.payload._id ? action.payload : subg),
                subGrupo: action.payload
            }
        case OBTENER_SUBGRUPO:
            return {
                ...state,
                subGrupo: action.payload
            }
        default:
            return state;
    }
}